var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#4A2FBD"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M0 10.3319H15.4301V15.8951H0V10.3319ZM0 0H15.4301V5.56321H0V0ZM27.6839 20.5842H0V26.1474H26.6465C29.5639 26.1474 36.3712 26.2267 38.8998 31.2337V28.1343C37.668 23.2066 34.0374 20.5842 27.6836 20.5842H27.6839ZM27.7484 30.9158H0V36.479H26.6465C33.1297 36.479 37.2142 36.7969 38.8998 37.9097V35.4458C37.603 31.5516 32.1572 30.9158 27.7486 30.9158H27.7484ZM27.6839 57.1425H0V51.5793H26.6465C29.5639 51.5793 36.3712 51.4999 38.8998 46.4929V49.5923C37.668 54.52 34.0374 57.1425 27.6836 57.1425H27.6839ZM27.7484 46.8109H0V41.2477H26.6465C33.1297 41.2477 37.2142 40.9297 38.8998 39.817V42.2808C37.603 46.175 32.1572 46.8109 27.7486 46.8109H27.7484ZM45.6424 66.7592H66V63.3415H46.2258C44.4752 63.3415 40.3263 63.2622 38.8351 60.3215V62.2291C39.5482 65.1695 41.7525 66.7592 45.6424 66.7592ZM45.5776 60.4805H65.9353V57.0631H46.2258C42.2709 57.0631 39.8073 56.9042 38.8348 56.189V57.699C39.6126 60.0832 42.9191 60.4805 45.5774 60.4805H45.5776Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBem);
export default __webpack_public_path__ + "static/media/bem.262c92be55df682a6f6663fb42c3c0ab.svg";
export { ForwardRef as ReactComponent };